// extracted by mini-css-extract-plugin
export default {"notification":"notification_notification__f0l8H","frameParent":"notification_frameParent__imD5r"};